// modules
// TODO: CHECK react-intl AND i18next AND $i18n
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import i18next from 'i18next'
import { getCurrentLanguage } from '$setup/internationalization'
import { areSameYear } from '$func/date'

export const SECOND_MS = 1000
export const MINUTE_MS = 60 * SECOND_MS
export const HOUR_MS = 60 * MINUTE_MS
export const DAY_MS = 24 * HOUR_MS

export const formatDuration = (duration: number, unit: 'ms' | 's' = 'ms') => {
  const durationInSeconds = Math.round(
    unit === 'ms' ? duration / 1000 : duration,
  )
  const hours = Math.floor(durationInSeconds / 3600)
  const minutes = Math.floor((durationInSeconds - hours * 3600) / 60)
  const remainingSeconds = durationInSeconds % 60

  return `${hours ? `${to2DigitPersianNumber(hours)}:` : ''}${to2DigitPersianNumber(minutes)}:${to2DigitPersianNumber(
    remainingSeconds,
  )}`
}

export const formatClock = (date: Date) => {
  return date.toLocaleString(getCurrentLanguage(), {
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
  })
}

export const formatDate = (date: Date) => {
  return date.toLocaleString(getCurrentLanguage(), {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  })
}

/**
 * @see http://www.ecma-international.org/ecma-262/5.1/#sec-15.9.1.1
 */
export const MAX_DATE = new Date(8.64e15)

export const shortDateFormatter = new Intl.DateTimeFormat(
  getCurrentLanguage(),
  { month: 'short', day: 'numeric' },
)

export const dateFormatter = new Intl.DateTimeFormat(getCurrentLanguage(), {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
})

export const dateTimeFormatter = new Intl.DateTimeFormat(getCurrentLanguage(), {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
})

export const dateTimeFormatterWithoutYear = new Intl.DateTimeFormat(
  getCurrentLanguage(),
  {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  },
)

export const to2DigitPersianNumber = (digit: number) =>
  digit.toLocaleString(getCurrentLanguage(), {
    minimumIntegerDigits: 2,
    useGrouping: false,
  })

export const dateDayFormatter = new Intl.DateTimeFormat(getCurrentLanguage(), {
  day: 'numeric',
})

export const yearFormatter = new Intl.DateTimeFormat(getCurrentLanguage(), {
  year: 'numeric',
})

export const monthFormatter = new Intl.DateTimeFormat(getCurrentLanguage(), {
  month: 'short',
})

export const monthAndYearFormatter = new Intl.DateTimeFormat(
  getCurrentLanguage(),
  { month: 'short', year: 'numeric' },
)

export const timeCalculation = (time: number) => {
  const date = new Date(time)

  if (areSameYear(date, new Date()))
    return date.toLocaleDateString(i18next.language, {
      month: 'short',
      day: 'numeric',
    })

  return date.toLocaleDateString(i18next.language, {
    month: 'short',
    year: 'numeric',
    day: 'numeric',
  })
}

export const weekInMilliSeconds = 7 * 24 * 60 * 60 * 1000
